export default {
  init() {
    $('.header-hamburger').click(function (e) {
      e.preventDefault();
      $('.nav-primary-mobile').slideToggle(300);
    });

    /*
    $('.trigger-form').click(function (e) {
      e.preventDefault();
      var targetId = $(this).context.hash;
      $('#embedded-form-wrapper, ' + targetId).show();
    });
    */
    $('.form-outer-wrapper').click(function (e) {
      e.stopPropagation();
    });
    $('#embedded-form-wrapper').click(function (e) {
      e.preventDefault();
      $(this).hide();
      $('.form-outer-wrapper').hide();
    });
    $('.trigger-video').click(function (e) {
      e.preventDefault();
      var videoId = $(this).data('videoId');
      $('#video-wrapper').show();
      $('#video-wrapper iframe').attr('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=true');
    });
    $('#video-wrapper').click(function (e) {
      e.preventDefault();
      $('#video-wrapper iframe').removeAttr('src');
      $('#video-wrapper').hide();
    });


    $('.popup-video').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      iframe: {
        patterns: {
          youtube: {
            index: 'youtube.com',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1',
          },
        },
      },
      removalDelay: 300,
      mainClass: 'mfp-fade',
      preloader: false,
      callbacks: {
        beforeOpen: function() {
          this.st.image.markup = this.st.image.markup.replace('mfp-fade', 'mfp-fade animated ' + 'zoomIn');
        },
      },
    });

    $('.trigger-form, .cta a[href="#support-form"]').magnificPopup({
      type: 'inline',
      preloader: false,
    });

    $('img[usemap]').rwdImageMaps();

    $('#menu-product-categories .more').attr('data-width', '80');

    $('<ul></ul>').insertAfter($('#menu-product-categories').find('.more a'));

    function calcWidth() {
      var navwidth = 0;
      var morewidth = $('#menu-product-categories .more').outerWidth(true);
      $('#menu-product-categories > li:not(.more)').each(function() {
        navwidth += $(this).outerWidth( true );
      });
      var availablespace = $('#menu-product-categories').outerWidth(true) - morewidth;

      if (navwidth > availablespace) {
        var lastItem = $('#menu-product-categories > li:not(.more)').last();
        lastItem.attr('data-width', lastItem.outerWidth(true));
        lastItem.prependTo($('#menu-product-categories .more ul'));
        calcWidth();
      } else {
        var firstMoreElement = $('#menu-product-categories li.more li').first();
        if (navwidth + firstMoreElement.data('width') < availablespace) {
          firstMoreElement.insertBefore($('#menu-product-categories .more'));
        }
      }

      if ($('.more li').length > 0) {
        $('.more').css('display','inline-block');
      } else {
        $('.more').css('display','none');
      }
    }
    $(window).on('resize load',function(){
      calcWidth();
    });

    $(window).on('load', function(){
      $('#menu-product-categories').addClass('initialized');
    });

    $('#find_dealer').click(function(e){
      e.preventDefault();
      location.href = $('#location').val();
    });


    $('a.live-chat').click(function(e){
      e.preventDefault();
      console.log("Chat");
      // $('#full-view-button').trigger('click');
      window.LC_API.open_chat_window({source:'minimized'})
    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
